import __request__ from "routing/request";
export function getAll(requestOptions) {
  return __request__("GET", "/system/pipelines/connections", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function connectStreams(JSONbody, requestOptions) {
  return __request__("POST", "/system/pipelines/connections/to_pipeline", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function connectPipelines(JSONbody, requestOptions) {
  return __request__("POST", "/system/pipelines/connections/to_stream", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPipelinesForStream(streamId, requestOptions) {
  return __request__("GET", `/system/pipelines/connections/${streamId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
